import { Component, Shark } from "shark-mvc";
import { Modal } from "bootstrap";
import { Tab } from "bootstrap";

import Project from "../../models/Project";
import User from "../../models/User";

import templateContent from "./project-detail-panel.html";

import messageModalComponent from "../messageModal/messageModalComponent";
import projectManager from "../../managers/projectManager";

class ProjectDetailPanelComponent extends Component {
	constructor () {
		super("projectDetailPanelComponent");

		this.addTemplate("", templateContent);
	}

	addProjectBtn_clickHandler () {
		const editingProject = new Project({
			ownerGuid: Shark.$store.currUser.guid,
			status: 1,
		});

		// editingProject.on("organizationGuidChanged", () => console.log("abbelle 1") && this.updateOrganizationUsersForPermission());
		// editingProject.on("organizationGuidChanged", () => console.log("abbelle 2") && this.updateOrganizationDetailsForPermission());
		// editingProject.on("organizationGuidChanged", () => console.log("abbelle 3") && this.updateOrganizationDetails());
		editingProject.on("organizationGuidChanged", () => {
			this.updateOrganizationUsersForPermission();
			this.updateOrganizationDetailsForPermission();
			this.updateOrganizationDetails();
		});

		// Queste sono tutte temporanee.
		editingProject.on("clientGuidChanged", () => Shark.render());
		editingProject.on("statusChanged", () => Shark.render());
		editingProject.on("valuationTypeChanged", () => Shark.render());

		Shark.set({
			editingProject,
			__organizationHasUsers: false,
			__isEditingProject: true,
		});
		// Shark.render();
		
		this.updateOrganizationUsersForPermission();
		this.updateOrganizationDetailsForPermission();
		
		this.toggleOpen();
	}

	afterLoad () {
		const modalNode = document.querySelector("#projectDetailModal");
		
		if (modalNode) {
			this.modal = new Modal(modalNode);
			modalNode.removeEventListener("hidden.bs.modal", this.hiddenbsmodal_handler);
			modalNode.addEventListener("hidden.bs.modal", this.hiddenbsmodal_handler);
		}
	}

	cancelProjectEditBtn_clickHandler () {
		this.close();
	}

	close () {
		const { selectedProject } = Shark.get();

		if (selectedProject) {
			selectedProject.off("organizationGuidChanged", this.updateOrganizationUsersForPermission);
			selectedProject.off("organizationGuidChanged", this.updateOrganizationDetailsForPermission);
		}

		Shark.set({
			selectedProject: null,
			__isEditingProject: false,
		});

		if (this.modal) {
			this.modal.hide();
		}
	}

	editProjectBtn_clickHandler (event, data) {
		event.preventDefault();
		event.stopPropagation();
		
		const selectedProjectGuid = data.guid.toString();
		const selectedProject = Shark.$store.projectList.find(item => item.guid === selectedProjectGuid);

		if (selectedProject) {
			const { clientList } = Shark.get();
			const newProjectClientList = clientList.filter(item => item.organizationGuid === selectedProject.organizationGuid);

			// selectedProject.on("organizationGuidChanged", () => {
			// 	this.updateOrganizationUsersForPermission();
			// 	this.updateOrganizationDetailsForPermission();
			// });
			selectedProject.on("organizationGuidChanged", () => {
				this.updateOrganizationUsersForPermission();
				this.updateOrganizationDetailsForPermission();
				this.updateOrganizationDetails();
			});
			// selectedProject.on("organizationGuidChanged", this.updateOrganizationUsersForPermission);
			// selectedProject.on("organizationGuidChanged", this.updateOrganizationDetailsForPermission);
			
			// Queste sono tutte temporanee.
			selectedProject.on("clientGuidChanged", () => Shark.render());
			selectedProject.on("statusChanged", () => Shark.render());
			selectedProject.on("valuationTypeChanged", () => Shark.render());
			
			Shark.set({
				editingProject: selectedProject,
				newProjectClientList,
			});

			this.updateOrganizationUsersForPermission();
			this.updateOrganizationDetailsForPermission();

			this.open();
		}
	}

	fastSaveField_keyupHandler (event) {
		// @Dave: mac users don't use control but command
		if (event.keyCode === 83 && event.ctrlKey) {
			this.saveEditingProject();
		}
	}

	hiddenbsmodal_handler () {
		Shark.set({
			selectedProject: null,
			__isEditingProject: false,
		});
	}

	init () {
		this.addComponents([messageModalComponent]);

		Shark.set({
			_saveEditingProjectBtnStatusCSSClasses: "btn-success",
			__isEditingProject: false,
		});
	}
	
	open () {
		const triggerEl = document.querySelector(`#projectDetailModal button[data-bs-target=".project-tab-pane"]`);
		Tab.getOrCreateInstance(triggerEl).show();

		if (this.modal) {
			// Dave: Questo serve per ora, non togliere!
			Shark.render();
			this.modal.show();
		}		
	}

	async saveEditingProject () {
		const { editingProject } = Shark.get();

		if (editingProject) {
			//Dave.Warn: questa cosa è bruttina, perché ho due comportamenti diversi nel dataChange e nel parse, dovrei uniformare

			const validationError = editingProject.validate();

			if (validationError.length > 0) {
				validationError.forEach(error => {
					document.querySelectorAll(`[data-sh-validate="${error.field}"]`).forEach(item => item.classList.remove("invalid")); 
					setTimeout(() => {
						document.querySelectorAll(`[data-sh-validate="${error.field}"]`).forEach(item => item.classList.add("invalid")); 
					}, 250);
				});

				let id = document.querySelector(`[data-sh-validate="${validationError[0].field}"]`).closest(".tab-pane").getAttribute("data-reference-tab");
				let errorTab = Tab.getInstance(document.getElementById(id));
				errorTab?.show();
				// ("Attenzione, si sono verificati i seguenti errori:\n\n" + errors.join("\n"));
			}
			else {
				Shark.set({
					_saveEditingProjectBtnStatusCSSClasses: "btn-warning disabled",
				});
				await projectManager.save(editingProject);
				Shark.set({
					_saveEditingProjectBtnStatusCSSClasses: "btn-success",
					newlyAddedProject: editingProject,
				});
				this.close();

				// console.log("Emetto il project_saved");
				this.emit("project_saved");
				//Questo andrebbe fatto con un evento
				// if (Shark.activePage.refreshProjectList) {
				// 	Shark.activePage.refreshProjectList();
				// }
			}
		}
	}

	saveEditingProjectBtn_clickHandler () {
		this.saveEditingProject();
	}

	// async saveProjectPermissionBtn_clickHandler () {
	// 	const { editingProject } = Shark.get();

	// 	if (editingProject) {
	// 		// editingProject.userList. User2Project
	// 		// editingProject.set({
	// 		// 	clientGuid: Shark.get("activeItems").newProjectClientGuid,
	// 		// 	name: Shark.get("activeItems").newProjectName,
	// 		// });
			
	// 		await projectManager.save(editingProject);
	// 	}
	// }

	// setProjectPermissionBtn_clickHandler () {
	// 	this.close();
	// }

	toggleOpen () {
		if (Shark.$store.__projectDetailModalVisibile) {
			this.close();
		}
		else {
			this.open();
		}
	}

	toggleProjectEditing () {
		// const { editingProject } = Shark.get();

		Shark.$store.__isEditingProject = !Shark.$store.__isEditingProject;
		// editingProject.updateScreenWithModelValues();
	}

	async toggleProjectEditingBtn_clickHandler () {
		const { editingProject } = Shark.get();

		if (Shark.$store.__isEditingProject && editingProject.isDirty()) {
			const confirmResponse = await messageModalComponent.open(Shark.$store.labels.warning_changes_not_saved, {
				cancelButtonLabel: "Annulla le modifiche",
				okButtonLabel: "Continua a modificare",
				showCancelButton: true,
			});

			if (confirmResponse) {
				return;
			}

			if (editingProject.guid === "") {
				this.close();
			}
			else {
				editingProject.restore();
				// Dave.ToDo: Provarlo così e fare sondaggio tra gli utenti.
				// this.close();
			}
		}

		if (editingProject.guid === "") {
			this.close();
		}
		else {
			this.toggleProjectEditing();
		}
	}

	updateOrganizationDetails () {
		let { editingProject } = Shark.get();

		if ( editingProject ) {
			const { clientList } = Shark.get();
			const newProjectClientList = clientList.filter(item => item.organizationGuid === editingProject.organizationGuid);

			Shark.set({
				__organizationHasClients: newProjectClientList.length > 0,
			});		
		}
	}

	updateOrganizationDetailsForPermission () {
		const { allUserList, allUserMembershipList, currUser } = Shark.get();
		let {editingProject } = Shark.get();

		if (allUserList && allUserMembershipList && editingProject) {
			const selectedOrganizationGuid = editingProject.organizationGuid;
			
			if (selectedOrganizationGuid) {					
				// editingProject.parseProjectPermissions();
				editingProject.parseUserProjectPermissions();
			}
			// Alice: no org selected (case new project || case starter/free)
			else {
				editingProject.__currUserCanSeeProjectCustomerField = currUser._feature_customer;
				editingProject.__currUserCanSeeProjectEconomicField = false;
				editingProject.__currUserCanChangePermission = currUser._feature_permission;
				editingProject.__currUserCanEditProjectCustomerField = currUser._feature_customer;
				editingProject.__currUserCanEditProjectEconomicField = false;
				editingProject.__currUserCanEditProjectGenericField = true;
				editingProject.__currUserCanEditProjectOrganizationField = [User.SUBSCRIPTION_TYPE_FREE, User.SUBSCRIPTION_TYPE_STARTER].includes(currUser.subscriptionType) ? false : true;
			}

			Shark.set({
				editingProject,
			});

			Shark.render();
		}
	}

	updateOrganizationUsersForPermission () {
		const { allUserList, allUserMembershipList, currUser, editingProject } = Shark.get();

		if (allUserList && allUserMembershipList && editingProject) {
			const selectedOrganizationGuid = editingProject.organizationGuid;

			if (selectedOrganizationGuid) {
				// Dave: serve anche filtro per status o prendo solo quelle attive dalle API?
				const otherUserList = allUserList.filter(user => {
					if (user.guid === currUser.guid) {
						return false;
					}
					
					const membership = allUserMembershipList.find(membership => membership.userGuid === user.guid && membership.organizationGuid === selectedOrganizationGuid);

					if (membership) {
						user._nameInActiveOrganization = membership.inviteName;

						return true;
					}

					return false;
				});
				
				Shark.set({
					__organizationHasUsers: otherUserList.length > 0,
					otherUserList,
				});
			}
		}
	}
}

const projectDetailPanelComponent = new ProjectDetailPanelComponent();

Shark.registerComponent(projectDetailPanelComponent);

export default projectDetailPanelComponent;